// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button } from "@revvsales/components";

// Components Imports
import { WorkFlowApproveReject } from "../../Popups";

// Internal Imports
import APPROVE from "../../../../assets/Approve-Icon.png";

class workflowApprovalBtn extends Component {
  state = {
    confirmationView: "",
    showWorkFlowApproveRejectModal: false,
  };

  _onBtnClick = view => {
    this.setState({
      confirmationView: view,
      showWorkFlowApproveRejectModal: true,
    });
  };

  _closeConfirmationModal = () => {
    this.setState({
      showWorkFlowApproveRejectModal: false,
    });
  };

  render() {
    if (this.props.showWFApproveRejectBtn) {
      const { confirmationView, showWorkFlowApproveRejectModal } = this.state;
      return (
        <Fragment>
          {/* ----- COMPONENT SECTION STARTS ----- */}
          <div className="workflowapprovalbtn-outer-wrapper">
            <div className="workflowapprovalbtn-wrapper">
              <img
                src={APPROVE}
                alt="Revv"
                className="workflowapprovalbtn-icon"
              />
              <div className="workflowapprovalbtn-txt">
                Please review this document and Approve or Reject as required
              </div>
              <Button
                className="workflowapprovalbtn-accept-btn"
                data-test="workflowapprovalbtn-accept-btn"
                onClick={() => {
                  this._onBtnClick("approve");
                }}>
                Approve
              </Button>
              <Button
                className="workflowapprovalbtn-reject-btn"
                data-test="workflowapprovalbtn-reject-btn"
                onClick={() => {
                  this._onBtnClick("reject");
                }}>
                Reject
              </Button>
            </div>
          </div>
          {/* ----- COMPONENT SECTION ENDS ----- */}

          {/* ----- POPUP SECTION STARTS ----- */}
          {/* ACCEPT OR REJECT AN APPROVAL FLOW POPUP */}
          {showWorkFlowApproveRejectModal && (
            <WorkFlowApproveReject
              view={confirmationView}
              onClose={this._closeConfirmationModal}
            />
          )}
          {/* ----- POPUP SECTION STARTS ----- */}
        </Fragment>
      );
    }

    return null;
  }
}

const mapStateToProps = state => {
  const {
    pendingApprovalRequired: showWFApproveRejectBtn,
  } = state.DocumentStore;

  return { showWFApproveRejectBtn };
};

export default connect(mapStateToProps)(workflowApprovalBtn);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/workflowApprovalBtn/index.js